import request from '@/utils/request'

// 获取基础统计数据-农家乐总数,今日游客数,今年游客总数,历史游客数

export function dpGetBasic(data) {
  return request({
    url: '/dp/getBasic',
    method: 'get',
    data: data
  })
}
// 地区分布统计
export function statistics(data) {
  return request({
    url: '/dp/region/statistics',
    method: 'get',
    data: data
  })
}
// 性别分布
export function genderStatistics(data) {
  return request({
    url: '/dp/Gender/Statistics',
    method: 'get',
    data: data
  })
}
// 年龄分布段
export function ageGenderStatistics(data) {
  return request({
    url: '/dp/age-gender/statistics',
    method: 'get',
    data: data
  })
}
//  农家乐列表
export function agritainmentList(data) {
  return request({
    url: '/dp/agritainment/list',
    method: 'get',
    data: data
  })
}
// 农家乐详情
export function detail(data) {
  return request({
    url: '/dp/agritainment/detail',
    method: 'get',
    params: data
  })
}
// 获取巡检记录
export function getInspectionsByAgritainment(data) {
  return request({
    url: '/dp/agritainment/getInspectionsByAgritainment',
    method: 'get',
    params: data
  })
}
// 巡检详情
export function getInspectionsById(data) {
  return request({
    url: '/dp/agritainment/getInspectionsById',
    method: 'get',
    params: data
  })
}
// 入驻情况
export function getAgritainmentGuestList(data) {
  return request({
    url: '/dp/agritainment/getAgritainmentGuestList',
    method: 'get',
    params: data
  })
}

// 农家乐搜索
export function pageList(data) {
  return request({
    url: '/dp/agritainment/pageList',
    method: 'get',
    params: data
  })
}
// 获取固定评级二维码
export function fixedRatingQrCode(data) {
  return request({
    url: '/dp/fixedRatingQrCode',
    method: 'get',
    params: data
  })
}